import { FC } from 'react';
import { withStyles, Card } from 'vopay';
import styles from './AddMethodMenu.module.scss';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { UtilButton } from 'UI';
import { useTranslation } from 'react-i18next';

const cn = withStyles(styles);

type AddMethodMenuProps = {
  disabled: boolean;
  onRequestClick: () => void;
  onProvideClick: () => void;
};

const AddMethodMenu: FC<AddMethodMenuProps> = ({ disabled, onRequestClick, onProvideClick }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Customers.PaymentMethodsTab.AddMethodMenu' });

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <UtilButton iconLeft="add" disabled={disabled}>
          {t('add', { defaultValue: 'Add' })}
        </UtilButton>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content sideOffset={8} className={cn('contentContainer')} align="end">
          <Card
            style={{
              padding: '8px',
              borderRadius: 12,
              borderColor: '#2d2d2d4d',
            }}
            className={cn('menu')}
          >
            <DropdownMenu.Item asChild>
              <button onClick={onRequestClick} className={cn('item')}>
                {t('request', { defaultValue: 'Request' })}
              </button>
            </DropdownMenu.Item>

            <DropdownMenu.Item asChild>
              <button onClick={onProvideClick} className={cn('item')}>
                {t('provide', { defaultValue: 'Provide' })}
              </button>
            </DropdownMenu.Item>
          </Card>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default AddMethodMenu;
